import React from "react";
import LocalDateTime from "services/date-converter";
import Chip from "../../../components/Chip";
import StatusPill from "../../components/StatusPill";
import { CASE_STATUS } from "../../features/monitor.constants";
import { closeReasonText, subjectKeyText } from "../../features/monitor.utils";

const When = ({ value }) => (value ? <span className="text-xs text-text_secondary"><LocalDateTime utcTime={value} /></span> : <span className="text-xs text-text_muted">—</span>);

// Columns of the Cases list. `start` is the row number offset of the current page.
export const getInstanceColumns = (start) => [
  { key: "id", label: "S.No", width: "70px", sortable: false, render: (row) => <span className="text-xs text-text_muted">{start + row.__index + 1}</span> },
  {
    key: "rule_fid",
    label: "Rule",
    sortable: true,
    render: (row) => (
      <div className="flex min-w-0 flex-col">
        <span className="truncate font-medium text-text_primary">{row.rule?.name ?? `Rule #${row.rule_fid}`}</span>
        <span className="truncate font-mono text-[11px] text-text_muted">{row.rule?.code}</span>
      </div>
    ),
  },
  {
    key: "subject_user_fid",
    label: "About",
    sortable: false,
    render: (row) => (
      <div className="flex min-w-0 flex-col">
        <span className="truncate text-xs text-text_primary">{row.subject_user?.name ?? subjectKeyText(row.subject_key)}</span>
        <span className="truncate text-[11px] text-text_muted">{row.project ? `${row.project.title} · Job ${row.project.file_id}` : `Ref ${row.reference_key}`}</span>
      </div>
    ),
  },
  {
    key: "status",
    label: "Status",
    sortable: true,
    render: (row) => (
      <div className="flex flex-col items-start gap-0.5">
        <StatusPill status={row.status} map={CASE_STATUS} />
        {row.status !== "OPEN" && row.resolved_reason && <span className="max-w-48 truncate text-[10px] text-text_muted">{closeReasonText(row.resolved_reason)}</span>}
      </div>
    ),
  },
  {
    key: "current_step",
    label: "Progress",
    sortable: true,
    render: (row) => (
      <div className="flex flex-wrap gap-1">
        <Chip tone={row.current_step > 1 ? "warning" : "default"}>step {row.current_step}</Chip>
        <Chip>{row.total_send_count} sent</Chip>
      </div>
    ),
  },
  { key: "next_due_at", label: "Next due", sortable: true, render: (row) => <When value={row.status === "OPEN" ? row.next_due_at : null} /> },
  { key: "last_sent_at", label: "Last sent", sortable: true, render: (row) => <When value={row.last_sent_at} /> },
  { key: "created_date", label: "Opened", sortable: true, render: (row) => <When value={row.created_date} /> },
];
